<template>
  <div>
    <v-data-table :headers="headers" :items="items" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <!-- <v-toolbar-title>Salary Logs</v-toolbar-title> -->
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            class="mb-2 normal-case"
            small
            outlined
            @click="openUploadDialog"
          >
            <v-icon left>mdi-plus</v-icon>
            Add Logs</v-btn
          >
        </v-toolbar>
      </template>
    </v-data-table>

    <v-dialog v-model="uploadDialog" max-width="900px" persistent>
      <GenericBulkUpload
        v-if="uploadDialog"
        title="Upload Salary Logs"
        subtitle="Upload salary logs using Excel file"
        entityName="Salary Log"
        :requiredColumns="requiredColumns"
        uploadEndpoint="/org/salary-logs/bulk-upload"
        :sampleData="sampleData"
        @close="closeUploadDialog"
        @uploadComplete="handleUploadComplete"
      />
    </v-dialog>
  </div>
</template>

<script>
import GenericBulkUpload from '@/components/Workforce/CollectionManagement/GenericBulkUpload.vue'

export default {
  name: 'SalaryLogs',
  components: {
    GenericBulkUpload
  },
  data: () => ({
    uploadDialog: false,
    headers: [
      { text: 'Employee ID', value: 'employeeId' },
      { text: 'Amount', value: 'amount' },
      { text: 'Month', value: 'month' },
      { text: 'Year', value: 'year' },
      { text: 'Payment Date', value: 'paymentDate' },
      { text: 'Status', value: 'status' }
    ],
    items: [],
    requiredColumns: ['Employee ID', 'Amount', 'Month', 'Year', 'Payment Date'],
    sampleData: [
      {
        'Employee ID': 'EMP001',
        Amount: 50000,
        Month: 'January',
        Year: 2024,
        'Payment Date': '2024-01-31'
      },
      {
        'Employee ID': 'EMP002',
        Amount: 60000,
        Month: 'January',
        Year: 2024,
        'Payment Date': '2024-01-31'
      }
    ]
  }),
  methods: {
    openUploadDialog() {
      this.uploadDialog = true
    },
    closeUploadDialog() {
      this.uploadDialog = false
    },
    handleUploadComplete(response) {
      this.$toast.success('Salary logs uploaded successfully')
      // Refresh list or add items from response if applicable
      // this.fetchSalaryLogs()
      this.closeUploadDialog()
    }
  }
}
</script>
